import { useState } from "react";
import { money } from "../../lib/api";
import { Card, F, PageHeader, Toggle, num } from "../../components/admin/ui";

const COSTS = [
  ["fabric", "تكلفة القماش"], ["tailoring", "الخياطة"], ["embroidery", "التطريز والإكسسوارات"],
  ["packaging", "التغليف والكرت"], ["inbound", "شحن البضاعة إليكِ (للقطعة)"], ["other", "تكاليف أخرى"],
];

const Out = ({ l, v, big, testid, tone = "" }) => (
  <div className={`flex justify-between border-b border-gray-100 py-2.5 ${big ? "text-lg font-bold" : "text-sm"}`}>
    <span className="text-gray-600">{l}</span><span data-testid={testid} className={tone}>{v}</span>
  </div>
);

export default function Calculator() {
  const [c, setC] = useState({ fabric: "", tailoring: "", embroidery: "", packaging: "", inbound: "", other: "", margin: 40, vat: true, rate: 15, fee: 0, price: "" });
  const set = (k) => ({ value: c[k], onChange: (v) => setC({ ...c, [k]: v }) });

  const cost = COSTS.reduce((s, [k]) => s + num(c[k]), 0);
  const vatMul = c.vat ? 1 + num(c.rate) / 100 : 1;
  const feeMul = 1 - num(c.fee) / 100;
  const m = Math.min(num(c.margin), 95) / 100;
  const netNeeded = m < 1 ? cost / (1 - m) : 0;
  const suggested = feeMul > 0 ? Math.ceil((netNeeded * vatMul) / feeMul) : 0;
  const price = num(c.price) || suggested;
  const netFromPrice = (price * feeMul) / vatMul;
  const profit = netFromPrice - cost;
  const realMargin = netFromPrice ? (profit / netFromPrice) * 100 : 0;

  return (
    <div data-testid="admin-calculator">
      <PageHeader title="حاسبة التسعير" desc="احسبي تكلفة القطعة والسعر المقترح للعميلة وصافي الربح. أدخلي تكلفة المنتج في صفحة المنتج ليُحسب الربح في المحفظة." />
      <div className="grid gap-4 lg:grid-cols-2">
        <Card title="تكاليف القطعة الواحدة (ر.س)">
          <div className="grid gap-3 sm:grid-cols-2">
            {COSTS.map(([k, l]) => <F key={k} label={l} type="number" testid={`calc-${k}`} {...set(k)} />)}
          </div>
          <div className="mt-4 grid gap-3 sm:grid-cols-2">
            <F label="نسبة الربح المطلوبة %" type="number" testid="calc-margin" {...set("margin")} />
            <F label="عمولة الدفع % (إن وجدت)" type="number" testid="calc-fee" {...set("fee")} />
            <Toggle label="السعر شامل ضريبة القيمة المضافة" checked={c.vat} onChange={(v) => setC({ ...c, vat: v })} />
            {c.vat && <F label="نسبة الضريبة %" type="number" {...set("rate")} />}
          </div>
        </Card>
        <Card title="النتيجة">
          <Out l="إجمالي تكلفة القطعة" v={`${money(cost)} ر.س`} testid="calc-total-cost" />
          <Out l="السعر المقترح للعميلة" v={`${money(suggested)} ر.س`} big testid="calc-suggested-price" />
          <div className="my-4"><F label="أو جرّبي سعر بيع آخر (ر.س)" type="number" testid="calc-price" {...set("price")} /></div>
          <Out l="سعر البيع المحسوب" v={`${money(price)} ر.س`} />
          {c.vat && <Out l="الضريبة من السعر" v={`${money(price - price / vatMul)} ر.س`} />}
          {num(c.fee) > 0 && <Out l="عمولة الدفع" v={`${money(price * (1 - feeMul))} ر.س`} />}
          <Out l="صافي الإيراد" v={`${money(netFromPrice)} ر.س`} />
          <Out l="صافي الربح للقطعة" v={`${money(profit)} ر.س`} big testid="calc-profit" tone={profit < 0 ? "text-red-600" : "text-green-700"} />
          <Out l="هامش الربح الفعلي" v={`${realMargin.toFixed(1)}%`} testid="calc-margin-real" />
        </Card>
      </div>
    </div>
  );
}
